const footerNav = [
  {
    title: "片单导航",
    links: [
      { href: "#overview", label: "片单总览" },
      { href: "#ranking", label: "推荐排行榜" },
      { href: "#themes", label: "主题合集" },
      { href: "#new", label: "最新片单" },
    ],
  },
  {
    title: "深入看片",
    links: [
      { href: "#classics", label: "经典高分" },
      { href: "#directors", label: "导演风格" },
      { href: "#guide", label: "观影指南" },
      { href: "#faq", label: "常见问答" },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-accent-950">
      <div className="mx-auto w-full max-w-[1280px] px-4 py-12 md:px-6 md:py-14">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-[1.4fr_1fr_1fr]">
          <div>
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-background-50/10 text-primary-300">
                <i className="ri-film-line text-lg"></i>
              </span>
              <span className="font-heading text-lg font-bold text-background-50">
                韩影片单
              </span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-background-200/70">
              韩国伦理电影在线观看推荐片单：按排行榜与主题整理最新热门与经典高分合集，覆盖多样题材与风格，帮你省去盲目找片的时间。
            </p>
          </div>

          {footerNav.map((group) => (
            <div key={group.title}>
              <h4 className="font-heading text-sm font-bold text-background-50">
                {group.title}
              </h4>
              <ul className="mt-4 flex flex-col gap-2.5">
                {group.links.map((link) => (
                  <li key={link.href}>
                    <a
                      href={link.href}
                      className="text-sm font-label text-background-200/70 transition-colors hover:text-background-50"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 flex flex-col gap-4 border-t border-background-50/10 pt-6 sm:flex-row sm:items-center sm:justify-between">
          <p className="max-w-2xl text-xs leading-relaxed text-background-200/60">
            本站仅提供韩国伦理电影的片单整理与内容介绍，不提供任何影片的在线播放与下载。作品请通过正规流媒体平台、影展放映或正版收藏等合法渠道观看。
          </p>
          <p className="whitespace-nowrap text-xs font-label text-background-200/60">
            © 2026 韩影片单 · 仅作观影参考
          </p>
        </div>
      </div>
    </footer>
  );
}